//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventTopBackground from './background.vue';
import Breadcrumbs from './breadcrumbs.vue';
import Badges from './badges.vue';
import Description from './description.vue';
import Topics from './topics.vue';
import Stream from './stream.vue';
import Chat from './chat.vue';
import RegisterCard from '../registerCard/index.vue';
import Registered from '../registered.vue';
import Banner from './banner.vue';

export default {
  components: {
    EventTopBackground,
    Breadcrumbs,
    Badges,
    Description,
    Topics,
    Stream,
    Chat,
    RegisterCard,
    Registered,
    Banner,
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    eventStatus() {
      return this.$store.state.event.eventStatus;
    },
    topicStatus() {
      return this.$store.getters['event/topicStatus'];
    },
    isSubscribed() {
      return this.$store.state.event.isSubscribed;
    },
    isBreadcrumbsVisible() {
      return this.$app.config.common.currentCountry !== 'co';
    },
    isCo() {
      return this.$app.config.common.currentCountry === 'co';
    },
  },
  methods: {},
};
